import { syncPushAccount } from './auth';
import axios from 'axios';
import { chatLoginLocation } from './chatRoomNavigation';

export const groupwareApi = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

export const chatApi = axios.create({
  baseURL: '/chat-api/chat',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

function isFormDataPayload(data) {
  return typeof FormData !== 'undefined' && data instanceof FormData;
}

function attachToken(config) {
  const token = localStorage.getItem('token');
  config.headers = { ...(config.headers || {}) };

  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // 파일 첨부(FormData)는 브라우저/axios가 boundary를 포함한 Content-Type을 자동 생성해야 합니다.
  // axios 인스턴스 기본값(application/json)이 남아 있으면 multer가 파일을 못 받아 400이 발생할 수 있습니다.
  if (isFormDataPayload(config.data)) {
    delete config.headers['Content-Type'];
    delete config.headers['content-type'];
  }

  return config;
}

groupwareApi.interceptors.request.use(attachToken);
chatApi.interceptors.request.use(attachToken);

function clearAuthStorage() {
  syncPushAccount(0);
  localStorage.removeItem('token');
  localStorage.removeItem('user');
}

function isLoginRequest(url = '') {
  const u = String(url || '');
  return u === '/login' || u.endsWith('/login');
}

function onApiError(err) {
  const status = err?.response?.status;
  const url = err?.config?.url;

  if (status === 401 && !isLoginRequest(url)) {
    const hadToken = Boolean(localStorage.getItem('token'));
    clearAuthStorage();
    if (window.location.pathname !== '/login' || hadToken) {
      window.location.replace(chatLoginLocation(window.location.href));
    }
  }
  throw err;
}

groupwareApi.interceptors.response.use((r) => r, onApiError);
chatApi.interceptors.response.use((r) => r, onApiError);
